import type { SVGProps } from 'react';

type MarkProps = SVGProps<SVGSVGElement>;

const base = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

export function TonMark(props: MarkProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 2.5 21.5 8.5 12 21.5 2.5 8.5Z" />
      <path d="M12 2.5v19" />
      <path d="M2.5 8.5h19" />
    </svg>
  );
}

export function GramMark(props: MarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 240 240"
      fill="currentColor"
      stroke="none"
      {...props}
      strokeWidth={0}
    >
      <path d="M123.96 196.922c1.95-.63 4.33-2.33 5.605-4 1.55-2.042 55.84-101.87 56.555-103.992.324-.963.657-2.61.742-3.657.572-7.123-4.582-14.07-11.685-15.748-2.496-.6-107.6-.578-110.1.012-5.2 1.227-9.27 5.11-11.103 10.566-.742 2.208-.663 6.363.166 8.75.724 2.083 54.99 101.92 56.522 103.987 2.973 4 8.388 5.677 13.3 4.092zm-34.397-65.316l-25.12-47.354c-.002-1.618.744-2.842 2.178-3.57l1.156-.588h47.035l-.065 97.68c-.036-.005-11.37-20.78-25.184-46.167zm36.19-2.886V80.093h46.775l1.156.588c1.434.73 2.18 1.953 2.178 3.57-.002 1.092-2.172 5.182-24.962 47.036l-25.054 45.95c-.052.06-.094-21.773-.094-48.518z" />
    </svg>
  );
}

export function TelegramMark(props: MarkProps) {
  return (
    <svg {...base} {...props}>
      <path d="M21.5 3 2.5 10.2l6.4 2.4 2.4 6.4L21.5 3Z" />
      <path d="M21.5 3 8.9 12.6" />
    </svg>
  );
}

export function BagMark(props: MarkProps) {
  return (
    <svg {...base} {...props}>
      <path d="M12 2.8 20.5 7v10L12 21.2 3.5 17V7Z" />
      <path d="M3.5 7 12 11.4 20.5 7" />
      <path d="M12 11.4v9.8" />
    </svg>
  );
}

export function DomainMark(props: MarkProps) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="10" r="7.2" />
      <path d="M4.8 10h14.4" />
      <path d="M12 2.8c1.9 2 2.9 4.5 2.9 7.2s-1 5.2-2.9 7.2c-1.9-2-2.9-4.5-2.9-7.2S10.1 4.8 12 2.8Z" />
      <path d="M7 21.2h10" />
    </svg>
  );
}
